import { splitVersionChangeLabel } from "@nexus/contracts";

const AI_EDIT_PREFIX = "AI edit · ";
const HOOK_CHANGE_LABEL = /^Hook ([1-4]) · (direction|line)$/i;

const BRAND_FIELD_KEYS = ["productLink", "font", "logo", "disclaimer"] as const;

/** Stored write-time labels mapped to the version-preview field keys they changed. */
const FIELD_KEYS_BY_LABEL: Record<string, readonly string[]> = {
  Duration: ["duration"],
  "Hook package": ["hookPackage"],
  "Selected hook": ["selectedHookIndex"],
  "Age range": ["ageRange"],
  Gender: ["gender"],
  "Concept direction": ["conceptDirection"],
  "Concept line": ["conceptLine"],
  "CTA direction": ["ctaDirection"],
  "CTA line": ["ctaLine"],
  Notes: ["notes"],
  Preferences: ["preferences"],
  "Product link": ["productLink"],
  Font: ["font"],
  Logo: ["logo"],
  Disclaimer: ["disclaimer"],
  "Brand reset": BRAND_FIELD_KEYS,
};

export function briefHookFieldKey(hookIndex: number, field: "direction" | "line"): string {
  return `hook-${hookIndex}-${field}`;
}

export function parseBriefFieldChangeLabel(
  changeLabel: string | null | undefined,
): readonly string[] {
  if (!changeLabel) return [];
  const trimmed = changeLabel.trim();
  const label = trimmed.startsWith(AI_EDIT_PREFIX)
    ? trimmed.slice(AI_EDIT_PREFIX.length)
    : trimmed;

  const fixed = FIELD_KEYS_BY_LABEL[label];
  if (fixed) return fixed;

  const hook = HOOK_CHANGE_LABEL.exec(label);
  if (!hook) return [];
  return [
    briefHookFieldKey(Number(hook[1]), hook[2]!.toLowerCase() as "direction" | "line"),
  ];
}

/** Last version ≤ `upToVersion` whose change label names each preview field (merged labels list several). */
export function briefFieldBlameByKey(
  versions: readonly { version: number; changeLabel: string | null }[],
  upToVersion: number,
): Map<string, number> {
  const blame = new Map<string, number>();
  const chronological = [...versions]
    .filter((entry) => entry.version > 1 && entry.version <= upToVersion)
    .sort((a, b) => a.version - b.version);

  for (const entry of chronological) {
    for (const part of splitVersionChangeLabel(entry.changeLabel)) {
      for (const key of parseBriefFieldChangeLabel(part)) {
        blame.set(key, entry.version);
      }
    }
  }

  return blame;
}
